import React from 'react';

import { Box, Typography } from '@mui/material';

import { cardSx } from './Section';
import { tokens } from '../../theme';

// Stitch numbered cards ("01", "02" ...) in a responsive grid.
export default function NumberedCards({
  items,
  columns = 4,
}: {
  items: { title: string; body: React.ReactNode }[];
  columns?: 2 | 3 | 4;
}) {
  return (
    <Box
      component='ul'
      sx={{
        listStyle: 'none',
        p: 0,
        m: 0,
        mt: 4,
        display: 'grid',
        gap: 3,
        gridTemplateColumns: {
          xs: 'minmax(0, 1fr)',
          sm: 'repeat(2, minmax(0, 1fr))',
          lg: `repeat(${columns}, minmax(0, 1fr))`,
        },
      }}
    >
      {items.map((item, index) => (
        <Box
          component='li'
          key={item.title}
          sx={{ ...cardSx, p: 3 }}
        >
          <Typography
            aria-hidden='true'
            sx={{
              fontFamily: '"JetBrains Mono Variable", ui-monospace, monospace',
              fontWeight: 600,
              color: tokens.accentText,
              fontSize: '0.9375rem',
            }}
          >
            {String(index + 1).padStart(2, '0')}
          </Typography>
          <Typography
            component='h3'
            variant='h5'
            sx={{ mt: 2 }}
          >
            {item.title}
          </Typography>
          <Typography
            variant='bodySm'
            component='div'
            sx={{ mt: 1, color: tokens.onSurfaceVariant, overflowWrap: 'anywhere' }}
          >
            {item.body}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
